import * as React from "react";
import './Intro.css';
import './Pick.css';
import '../../components/Typograph.css';
import AppHeader from '../../components/AppHeader';
import AppFooter from '../../components/AppFooter';
import PropTypes from "prop-types";

Intro.propTypes = {
    handleNextPage: PropTypes.func.isRequired
}

export default function Intro(props) {
    return (
        <div className="page">
            <AppHeader title="Introductie scherm"/>

            <div className="page-middle">
                <h1 className="welcome-title">Een vrijblijvende offerte op uw situatie afgesteld.</h1>
                <p className="welcome-text">
                    Hier kunt u uw situatie achterlaten.<br/>
                    Een specialist stelt de benodigde producten voor u samen.<br/>
                    Vervolgens krijgt u een vrijblijvend voorstel in uw email.<br/>
                </p>
                <p className="detail-welcome-text-bottom">
                    Klik op de knop hieronder om door te gaan.
                </p>
            </div>

            <AppFooter onNext={props.handleNextPage}/>
        </div>
    );
}